module.exports = __webpack_public_path__ + "img/penguin_hat.d4ebdcb9.svg";